export default function prefixUrlWithLocale(
  url: string,
  localeCode: string,
): string | undefined {
  if (url) {
    return url?.charAt(0) === '/'
      ? localeCode === 'us-en'
        ? url
        : '/' + localeCode + url
      : url;
  }

  return undefined;
}
